import { Heading, Text, VStack } from 'native-base'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useConfig } from '../../context/config'

import { REDIRECTION_REASON_REFERRAL, REDIRECTION_REASON_REFERRAL_ERROR } from './redirect-reasons'

export const WelcomeHeading = ({ redirectionReason }: { redirectionReason?: string }) => {
  const { t } = useTranslation()
  const { config } = useConfig()

  const headingText = useMemo(() => {
    if (redirectionReason === REDIRECTION_REASON_REFERRAL)
      return t('screens.referral.heading', { partnerName: config.partnerName })
    if (redirectionReason === REDIRECTION_REASON_REFERRAL_ERROR) return t('screens.referral.expired.heading')

    return t('screens.welcome.heading')
  }, [redirectionReason])

  const subHeadingText = useMemo(() => {
    if (redirectionReason === REDIRECTION_REASON_REFERRAL)
      return t('screens.referral.text', { partnerName: config.partnerName })
    if (redirectionReason === REDIRECTION_REASON_REFERRAL_ERROR)
      return t('screens.referral.expired.text', { partnerName: config.partnerName })

    return t('screens.welcome.subHeading')
  }, [redirectionReason])

  return (
    <VStack marginTop={6}>
      <Heading color={'neutral.900'} fontSize={'20px'} testID="welcome-screen-title">
        {headingText}
      </Heading>

      <Text mt={2} color="neutral.700" fontSize="md">
        {subHeadingText}
      </Text>
    </VStack>
  )
}
